import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import * as Util from '../../../common/utilities';

import { Button, Modal } from '@salesforce/design-system-react';
import { PickExperimentWinner } from '../';
import './ExperimentModal.scss';

class EndExperimentModal extends Component {
  constructor(props) {
    super(props);
    this.modalName = 'endExperiment';
  }

  getI18nID(suffix) {
    return `components.experiment.endModal.${suffix}`;
  }

  // ===================================
  // =         Event Handlers          =
  // ===================================
  handleEnd() {
    if (this.props.modals.endExperiment.data?.selectedRow?.uuid) {
      this.props.actions.selectWinner(
        this.props.modals.endExperiment.data,
        this.props.context,
        { cToken: this.props.session.experimentCsrfToken }
      );
    }
    this.props.actions.endExperiment(
      this.props.modals.endExperiment.data,
      this.props.context,
      { cToken: this.props.session.experimentCsrfToken }
    );
    this.closeModal();
  }

  // ===================================
  // =           Actions               =
  // ===================================
  closeModal() {
    this.props.actions.closeModal(this.modalName);
  }

  // ===================================
  // =        React Lifecycle          =
  // ===================================
  componentDidUpdate(prevProps) {
    const isOpen = 'modals.deleteExperiment.isOpen';

    if (Util.propChanged(prevProps, this.props, isOpen, true)) {
      this.props.actions.getExperiments();
    }
  }

  // ===================================
  // =           Rendering             =
  // ===================================
  renderFooter() {
    const { formatMessage } = this.props.intl;
    /**
     * Cancel
     */
    const cancelLabel = formatMessage({
      id: 'components.experiment.common.cancel'
    });
    const cancelButton = (
      <Button
        label={cancelLabel}
        variant="neutral"
        onClick={this.closeModal.bind(this)}
      />
    );

    /**
     * Save
     */
    const endLabel = formatMessage({
      id: this.getI18nID('actionButtons.end')
    });
    const endButton = (
      <Button
        id="experimentDeleteButton"
        label={endLabel}
        variant="brand"
        onClick={this.handleEnd.bind(this)}
      />
    );

    return (
      <div className="footer-button-actions">
        <div className="footer-button-actions-right">
          {cancelButton}
          {endButton}
        </div>
      </div>
    );
  }

  renderEndExperiment() {
    return (
      <div className="end-slds-card-wrapper">
        <div className="slds-grid">
          <div className="end-description">
            <div className="end-header">
              <FormattedMessage id={this.getI18nID('description')} />
            </div>
            <PickExperimentWinner
              actions={this.props.actions}
              experiment={this.props.modals?.endExperiment?.data}
              onRowSelect={selection => this.handleRowSelect(selection)}
              context="winner"
              selectable
            />
          </div>
        </div>
      </div>
    );
  }

  renderModal() {
    return this.renderEndExperiment();
  }

  render() {
    const { formatMessage } = this.props.intl;
    const isOpen =
      this.props.modals[this.modalName] &&
      this.props.modals[this.modalName].isOpen;
    const modalTitle = formatMessage({
      id: this.getI18nID('title')
    });

    if (!isOpen) {
      return null;
    }

    return (
      <Modal
        heading={modalTitle}
        footer={this.renderFooter()}
        onRequestClose={this.closeModal.bind(this)}
        dismissOnClickOutside={false}
        //disableClose={true}
        isOpen={isOpen || false}
        contentClassName="end"
      >
        {this.renderModal()}
      </Modal>
    );
  }
}

EndExperimentModal.propTypes = {
  actions: PropTypes.object.isRequired,
  context: PropTypes.string,
  modals: PropTypes.object.isRequired,
  flags: PropTypes.object.isRequired,
  intl: intlShape.isRequired,
  session: PropTypes.object
};

export default injectIntl(EndExperimentModal);
